import React, { useEffect } from "react";
import './maskBackground.css';

interface MaskBackgroundProps {
    zIndex?: number;
    closeFunction?: () => void;
}

const MaskBackground: React.FC<MaskBackgroundProps> = ({ zIndex = 1, closeFunction }) => {
    useEffect(() => {
        const scrollY = window.scrollY;

        document.body.classList.add("scroll-lock");
        document.body.style.top = `-${scrollY}px`;

        return () => {
            document.body.classList.remove("scroll-lock");
            const savedScrollY = document.body.style.top;
            document.body.style.top = "";

            window.scrollTo(0, parseInt(savedScrollY || "0") * -1);
            
        };
    }, []);

    return (
        <div
            className="containerMaskBackground"
            style={{ zIndex }}
            onClick={() => {
                if (closeFunction) closeFunction();
            }}
        />
    );
};

export default MaskBackground;
